<template>
  <div id="app">
    <div id="content" class="addedit-person">
      <Header
        @validate="validate()"
        :page="this.$route.name"
        :title_one="this.type"
        :title_two="title_two"
        :title_three="edit ? 'edit' : 'add'"
        :action_one="edit ? 'update' : 'add'"
        :action_two="'cancel'"
      ></Header>
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <PersonEdit @add-update="validate()"></PersonEdit>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import PersonEdit from '@/components/ui/PersonEdit'
import Header from '@/components/layout/Header'

export default {
  name: 'PersonForm',
  components: {
    PersonEdit,
    Header
  },
  data () {
    return {
      edit: false,
      type: '',
      title_two: '',
      user: {}
    }
  },
  created () {
    this.user = this.$store.getters['user/getUser']
    if (
      this.user.admin &&
      Object.keys(this.$store.getters['club/getClub']).length < 1
    ) {
      this.$store
        .dispatch('club/loadClubEvent', {
          club_id: this.user.club_id,
          event_id: this.user.event_id
        })
        .then(function () {})
    }
    if (typeof this.$route.params.person_id !== 'undefined') {
      this.edit = true
    }
    // get type
    switch (this.$route.name) {
      case 'players_add':
      case 'player_edit':
        this.type = 'player'
        this.title_two = 'titles.players'
        break
      case 'staff_add':
      case 'staff_edit':
        this.type = 'staff'
        this.title_two = 'titles.staff'
        break
      case 'responsables_add':
      case 'responsable_edit':
        this.type = 'responsable'
        this.title_two = 'titles.responsables'
        break
      case 'acompanyants_add':
      case 'acompanyant_edit':
        this.type = 'acompanyant'
        this.title_two = 'titles.acompanyants'
        break
    }
  },
  methods: {
    validate () {
      this.$children[1].validate()
    }
  }
}
</script>

<style lang="scss" scoped>
#app {
  background-color: #fff;
  margin: 0;
  padding: 0;
  height: 100%;
}

#content.addedit-person {
  .box {
    width: 100%;
    margin: 0 auto;
    width: 80%;
    height: 80%;
    overflow: auto;
    text-align: center;

    .message.error {
      color: $warning-color;
    }

    .item {
      width: calc(50% - 20px);
      margin: 10px 10px;
      display: inline-block;

      label {
        font-size: 14px;
        padding: 0;
        margin-bottom: 5px;
        display: block;
      }

      input,
      select {
        width: 100%;
        padding: 15px;
        margin-bottom: 5px;
        border: 1px solid $secondary-color;
        outline: none;
        font-size: 11pt;
        border-radius: 3px;
        color: $dark-color;

        &::placeholder {
          color: $dark-color;
        }
      }
    }

    select option {
      font-size: 14pt;
    }

    button.btn {
      max-width: 300px;
      width: 100%;
      padding: 15px;
      outline: none;
      border: none;
      cursor: pointer;
      font-size: 12pt;
      font-family: Speedee-Bold;
      margin-top: 25px;
      border-radius: 3px;
      border: 1px solid $secondary-color;
      text-transform: uppercase;
      transition: all 0.5s;
      background: $main-color;
      color: $secondary-color;

      &:hover {
        background: $secondary-color;
        color: $dark-color;
      }
    }
  }

  @include media("<=desktop") {
    .box {
      width: 100%;
      padding: 0;
      margin: 0;
      .item {
        width: 100%;
        display: block;
        margin: 0;
      }
    }
  }
}
</style>
